/* eslint-disable guard-for-in */
import * as _ from 'lodash';
import toastr from 'toastr';
import moment from 'moment';
import {
  NEW_TASK,
  BULK_EDIT_TASK,
  disabledFunctionForPicklist,
  fetchOptionsForPicklist,
  PICKLIST_OPTIONS,
  TASK_FORM_MODE,
  ON_TASK_TYPE_CHANGE_FOR_LINKED_TASKS,
  buildPathFunctionForCustomAttributePicklist,
  buildSetValueFunctionForCustomAttributePicklist,
  buildPathFunctionForGlobalAttributePicklist,
  buildSetValueFunctionForGlobalAttributePicklist,
  findAffectingChild,
  getPicklistOptionText,
  getAssetsPreviewInfo,
} from '../lib/constants';
import * as UtilityFunctions from '../../../../../HelperMethods/UtilityFunctions';
import apiService from '../../../../../service/apiService';
import * as TaskUtilities from '../../../../../HelperMethods/TaskUtilities';
// eslint-disable-next-line import/no-cycle
import { DEFAULT_TASK_SCHEMA } from '../lib/schemaConstants';
import logUtils from '../../../../../HelperMethods/LogUtils';
import {
  getAccessOptionsForResourceAndUser,
  getFieldsAndAreasAccessibleToUser,
  determineIfUserHasFieldsDisabled,
} from '../../../../../HelperMethods/UserUtilities';
import { convertDbWorkflowToWorkflowTableData, getWorkflowTableData } from '../../../../../HelperMethods/workflowUtils';
import {
  ACCESS_OPTIONS,
  ENTITY_ACCESS_TYPE,
  RESOURCE_TYPE,
  RESOURCES,
} from '../../../../../HelperMethods/role-resource-constants';
import { STATUS_LIST, ASSET_TYPES } from '../../../../../HelperMethods/enums';
import { ATTRIBUTE_TYPE, getDefaultValue } from '../../../../../HelperMethods/FormUtils';
import { getPicklistIds, getFormElementsForAssetList } from '../../../../common/form-preview/FormUtils';
import {
  upsertTasks,
  bulkEditPageLoading,
  stopBulkEditPageLoading,
  upsertWatchers,
  upsertAssetLevelsInfo,
} from '../../redux/reducer';
import { setPicklistOptionsToState } from '../lib/Mapper';
// eslint-disable-next-line import/no-cycle
import { updateTaskInReducer } from './reducer';
import { loadPicklists } from '../../../../picklistAndPicklistMappingManagement/picklistManagement/redux/actions';
import { loadWatcherGroups } from '../../../../generalConfig/watcherGroupManagement/redux/actions';

const componentName = 'ManageTaskForm';
export const types = {
  LOAD_FORM_SCHEMA_AND_VALUES: `${componentName}_LOAD_FORM_SCHEMA_AND_VALUES`,
  LOAD_CREATE_FORM_SCHEMA_AND_VALUES: `${componentName}_LOAD_CREATE_FORM_SCHEMA_AND_VALUES`,
  LOADING_PICKLIST: `${componentName}_LOADING_PICKLIST`,
  LOAD_PICKLIST_SUCCESSFUL: `${componentName}_LOAD_PICKLIST_SUCCESSFUL`,
  LOAD_PICKLIST_FAILED: `${componentName}_LOAD_PICKLIST_FAILED`,
  RESET_TASK_FORM_COMPONENT: `${componentName}_RESET_TASK_FORM_COMPONENT`,
  LOADING_PICKLISTS: `${componentName}_LOADING_PICKLISTS`,
  STOP_LOADING_PICKLISTS: `${componentName}_STOP_LOADING_PICKLISTS`,
  LOAD_FORM_SCHEMA: `${componentName}_LOAD_FORM_SCHEMA`,
  LOAD_FORM_HISTORY: `${componentName}_LOAD_FORM_HISTORY`,
  LOADING_PICKLIST_FOR_CUSTOM_ATTRIBUTE: `${componentName}_LOADING_PICKLIST_FOR_CUSTOM_ATTRIBUTE`,
  LOADED_PICKLIST_FOR_CUSTOM_ATTRIBUTE_FAILED: `${componentName}_LOADED_PICKLIST_FOR_CUSTOM_ATTRIBUTE_FAILED`,
  LOADED_PICKLIST_FOR_CUSTOM_ATTRIBUTE_SUCCESSFULLY: `${componentName}_LOADED_PICKLIST_FOR_CUSTOM_ATTRIBUTE_SUCCESSFULLY`,
  LOADED_DEPENDENT_TASKS_SUCCESSFUL: `${componentName}_LOADED_DEPENDENT_TASKS_SUCCESSFUL`,
  LOADED_LINKED_TASKS_SUCCESSFUL: `${componentName}_LOADED_LINKED_TASKS_SUCCESSFUL`,
  LOADED_TASK_TEMPLATE_SUCCESSFUL: `${componentName}_LOADED_TASK_TEMPLATE_SUCCESSFUL`,
  LOADED_PARENT_TASK_TEMPLATE_SUCCESSFUL: `${componentName}_LOADED_PARENT_TASK_TEMPLATE_SUCCESSFUL`,
  LOADED_PARENT_TASK_TEMPLATE_ITEM_ASSIGNEE_SUCCESSFUL: `${componentName}_LOADED_PARENT_TASK_TEMPLATE_ITEM_ASSIGNEE_SUCCESSFUL`,
  UPDATE_PARENT_TASK_TEMPLATE_ITEM: `${componentName}_UPDATE_PARENT_TASK_TEMPLATE_ITEM`,
  LOAD_CREATE_LINK_TASK_FORM_SCHEMA_AND_VALUES: `${componentName}_LOAD_CREATE_LINK_TASK_FORM_SCHEMA_AND_VALUES`,
  DELETED_LINKED_TASK_SUCCESSFULLY: `${componentName}_DELETED_LINKED_TASK_SUCCESSFULLY`,
  LOADING_DEPENDENT_TASKS_SUCCESSFUL: `${componentName}_LOADING_DEPENDENT_TASKS_SUCCESSFUL`,
  LOADING_LINKED_TASKS: `${componentName}_LOADING_LINKED_TASKS`,
  LOADING_TASK_TEMPLATE: `${componentName}_LOADING_TASK_TEMPLATE`,
  LOADING_PARENT_TASK_TEMPLATE: `${componentName}_LOADING_PARENT_TASK_TEMPLATE`,
  CLEAR_PARENT_TASK_TEMPLATE: `${componentName}_CLEAR_PARENT_TASK_TEMPLATE`,
  LOADED_DEPENDENT_TASKS_FAILED: `${componentName}_LOADED_DEPENDENT_TASKS_FAILED`,
  LOADED_LINKED_TASKS_FAILED: `${componentName}_LOADED_LINKED_TASKS_FAILED`,
  LOADED_TASK_TEMPLATE_FAILED: `${componentName}_LOADED_TASK_TEMPLATE_FAILED`,
  LOAD_CREATE_BULK_FORM_SCHEMA_AND_VALUES: `${componentName}_LOAD_CREATE_BULK_FORM_SCHEMA_AND_VALUES`,
  LOADED_PARENT_TASK_TEMPLATE_FAILED: `${componentName}_LOADED_PARENT_TASK_TEMPLATE_FAILED`,
  GET_STOP: `${componentName}_GET_STOP`,
  GET_STOP_SUCCESS: `${componentName}_GET_STOP_SUCCESS`,
  GET_STOP_FAILED: `${componentName}_GET_STOP_FAILED`,
  CLEAR_STOP: `${componentName}_CLEAR_STOP`,
  BULK_ACCEPT_TASK: `${componentName}_BULK_ACCEPT_TASK`,
  LOADING_MANIFEST_FORM: `${componentName}_LOADING_MANIFEST_FORM`,
  LOAD_MANIFEST_FORM_SUCCESSFUL: `${componentName}_LOAD_MANIFEST_FORM_SUCCESSFUL`,
  LOAD_MANIFEST_FORM_FAILED: `${componentName}_LOAD_MANIFEST_FORM_FAILED`,
  CLEAR_MANIFEST_FORM: `${componentName}_CLEAR_MANIFEST_FORM`,
  SET_AUDIT_LOG_OF_MANIFEST_FORM: `${componentName}_SET_AUDIT_LOG_OF_MANIFEST_FORM`,
  UPDATE_TASK_AFTER_GENERATE_MULTIPLE: `${componentName}_UPDATE_TASK_AFTER_GENERATE_MULTIPLE`,
  SET_ADHOC_FILE_UPLOADING_STATUS: `${componentName}_SET_ADHOC_FILE_UPLOADING_STATUS`,
  LOAD_TASK_EMAIL_HISTORY_SUCCESSFUL: `${componentName}_LOAD_TASK_EMAIL_HISTORY_SUCCESSFUL`,
  LOAD_TASK_EMAIL_HISTORY_FAILED: `${componentName}_LOAD_TASK_EMAIL_HISTORY_FAILED`,
  LOADING_PREFERRED_LOCATION_PARENT_TASK_TEMPLATE_ITEM: `${componentName}_LOADING_PREFERRED_LOCATION_PARENT_TASK_TEMPLATE_ITEM`,
  LOADED_PREFERRED_LOCATION_PARENT_TASK_TEMPLATE_ITEM_SUCCESSFUL: `${componentName}_LOADED_PREFERRED_LOCATION_PARENT_TASK_TEMPLATE_ITEM_SUCCESSFUL`,
  CLEAR_PREFERRED_LOCATION_PARENT_TASK_TEMPLATE_ITEM: `${componentName}_CLEAR_PREFERRED_LOCATION_PARENT_TASK_TEMPLATE_ITEM`,
  UPDATE_PARENT_TASK_TEMPLATE: `${componentName}_UPDATE_PARENT_TASK_TEMPLATE`,
  IS_TASK_TYPE_PARENT: `${componentName}_IS_TASK_TYPE_PARENT`,
  LOADING_ASSET_CRITERIA: `${componentName}_LOADING_ASSET_CRITERIA`,
  LOAD_ASSET_CRITERIA_SUCCESSFUL: `${componentName}_LOAD_ASSET_CRITERIA_SUCCESSFUL`,
  LOAD_ASSET_CRITERIA_FAILED: `${componentName}_LOAD_ASSET_CRITERIA_FAILED`,
  LOAD_RULES_EVALUATED_SUCCESSFUL: `${componentName}_LOAD_RULES_EVALUATED_SUCCESSFUL`,
  LOAD_RULES_EVALUATED_FAILED: `${componentName}_LOAD_RULES_EVALUATED_FAILED`,
  SEARCH_PICKLIST_FOR_FORM: `${componentName}_SEARCH_PICKLIST_FOR_FORM`,
};

export function bulkAcceptTaskActionRedux(acceptBulkAccept) {
  return async (dispatch) => {
    dispatch({ type: types.BULK_ACCEPT_TASK, acceptBulkAccept });
  };
}

function getcustomPicklist(picklistOptionsWithAttributeNameList, customPicklistOptions) {
  picklistOptionsWithAttributeNameList.forEach((picklistOptionWithAttributeNameObj) => {
    const { attributeName, picklistOptions } = picklistOptionWithAttributeNameObj;
    const filteredPicklistOptionsSet = picklistOptions.sort(
      (option1, option2) => option1.sortOrder - option2.sortOrder
    );
    const picklistOptionsForDropdown = filteredPicklistOptionsSet.map((picklistOption) => ({
      key: picklistOption.id,
      value: picklistOption.id,
      text: picklistOption.name,
      originalobject: picklistOption,
    }));
    customPicklistOptions = setPicklistOptionsToState(
      customPicklistOptions,
      attributeName,
      false,
      picklistOptionsForDropdown
    );
  });
  return customPicklistOptions;
}

async function getTaskTypesByAreas(areas) {
  const response = await apiService.getTaskTypesByAreas({ areaIds: areas });
  const success = _.get(response, 'data.rpcService.success');
  if (success) {
    const taskTypesData = _.get(response, 'data.rpcService.output', '"[]"');
    const taskTypes = JSON.parse(JSON.parse(taskTypesData));
    return taskTypes;
  }
  let message = _.get(response, 'data.rpcService.message');
  message = message || 'Error fetching task types';
  throw new Error(message);
}

async function getTaskTypeByField(fieldId) {
  const paramObject = UtilityFunctions.getSearchGraphQLParamForFieldId(fieldId);
  const taskTypesResponse = await apiService.searchTaskTypes(paramObject);
  const taskTypes = _.get(taskTypesResponse, 'data.searchTaskTypes.items', []).map((taskType) => {
    // eslint-disable-next-line no-param-reassign
    taskType.schema = taskType.schema ? JSON.parse(taskType.schema) : {};
    return taskType;
  });
  return taskTypes;
}

export function loadTaskTypePicklist({ fieldId, areas, taskTypes, isCreate = false, loadForLinkedTask = false, selectedTaskTypeGroups = [] }) {
  return async (dispatch, getState) => {
    dispatch({ type: types.LOADING_PICKLIST, picklistType: PICKLIST_OPTIONS.TASK_TYPE });
    try {
      const { loggedInUser } = getState().appReducer;
      const { teams = [] } = getState().teamReducer;
      const loggedinUserTeams = (loggedInUser?.teams || []).filter((val) => !val.isDeleted);
      const teamsDict = _.keyBy(teams, 'id');
      let groupsListOfLoggedInUser = [];
      let groupRestriction = true;
      for (const team of loggedinUserTeams) {
        const reqTeam = teamsDict[team.teamId];
        const allowedGroups = reqTeam?.allowedTaskTypeCreateGroups ?? [];
        if (allowedGroups) {
          const teamGroups = allowedGroups.map((val) => val.id);
          if (!teamGroups?.length) {
            groupRestriction = false;
            break;
          }
          groupsListOfLoggedInUser = [...groupsListOfLoggedInUser, ...teamGroups];
        }
      }
      groupsListOfLoggedInUser = _.uniq(groupsListOfLoggedInUser);
      let taskTypeOptions;
      if (areas) {
        taskTypeOptions = await getTaskTypesByAreas(areas);
      } else if (fieldId) {
        taskTypeOptions = await getTaskTypeByField(fieldId);
      } else if (taskTypes) {
        taskTypeOptions = taskTypes;
      }
      if (isCreate && groupRestriction && groupsListOfLoggedInUser?.length) {
        taskTypeOptions = taskTypeOptions.filter((taskType) => {
          if (taskType.groups?.length) {
            const groupIds = taskType.groups.map((val) => val.id);
            const intersection = _.intersection(groupsListOfLoggedInUser, groupIds);
            return !!intersection?.length;
          }
          return true;
        });
      }
      if (isCreate && loadForLinkedTask) {
        taskTypeOptions = taskTypeOptions.filter((taskType) => !taskType.isDynamicParentChild);
      }
      // Filter by selected task type groups
      if (isCreate && selectedTaskTypeGroups?.length) {
        taskTypeOptions = taskTypeOptions.filter((taskType) => 
          TaskUtilities.doesTaskTypeBelongToSelectedGroup(taskType, selectedTaskTypeGroups)
        );
      }
      dispatch({
        type: types.LOAD_PICKLIST_SUCCESSFUL,
        picklistType: PICKLIST_OPTIONS.TASK_TYPE,
        entities: taskTypeOptions,
      });
      return taskTypeOptions;
    } catch (e) {
      const message = e instanceof Error ? 'Task Types Loading Failed' : e.message;
      logUtils.logError(e, message);
      dispatch({ type: types.LOAD_PICKLIST_FAILED, picklistType: PICKLIST_OPTIONS.TASK_TYPE });
      return [];
    }
  };
}

export function loadStopPicklist({ taskType, searchString, id }) {
  return async (dispatch, getState) => {
    dispatch({ type: types.LOADING_PICKLIST, picklistType: PICKLIST_OPTIONS.STOP, isSearching: true });
    let stops = [];
    try {
      const { selectedField } = getState().appReducer;
      const accessToFieldAndAreas = getFieldsAndAreasAccessibleToUser(getState().appReducer.loggedInUser);
      const areaIds = accessToFieldAndAreas[selectedField.id] ?? [];
      if (taskType && (searchString || id)) {
        const assetResponse = await apiService.getAssetsByTeamIdsAndAreaIds(
          [taskType.teamId],
          areaIds,
          searchString,
          ['stop'],
          null,
          null,
          id
        );
        stops = UtilityFunctions.inflateResponse(assetResponse);
        stops = (stops || []).filter((stop) => !stop.isDeleted);
      }
      dispatch({ type: types.LOAD_PICKLIST_SUCCESSFUL, picklistType: PICKLIST_OPTIONS.STOP, entities: stops });
    } catch (e) {
      logUtils.logError(e, 'Asset Loading Failed');
      dispatch({ type: types.LOAD_PICKLIST_FAILED, picklistType: PICKLIST_OPTIONS.STOP });
    }
    return stops;
  };
}
export function loadStopPicklistWithoutSearchString({ taskType, searchString, id }) {
  return async (dispatch, getState) => {
    dispatch({ type: types.LOADING_PICKLIST, picklistType: PICKLIST_OPTIONS.STOP, isSearching: true });
    let stops = [];
    try {
      const { selectedField } = getState().appReducer;
      const accessToFieldAndAreas = getFieldsAndAreasAccessibleToUser(getState().appReducer.loggedInUser);
      const areaIds = accessToFieldAndAreas[selectedField.id] ?? [];
      if (taskType) {
        const assetResponse = await apiService.getAssetsByTeamIdsAndAreaIds(
          [taskType.teamId],
          areaIds,
          searchString,
          ['stop'],
          null,
          null,
          id
        );
        stops = UtilityFunctions.inflateResponse(assetResponse);
        stops = (stops || []).filter((stop) => !stop.isDeleted);
      }
      dispatch({ type: types.LOAD_PICKLIST_SUCCESSFUL, picklistType: PICKLIST_OPTIONS.STOP, entities: stops });
    } catch (e) {
      console.error(e, 'Asset Loading Failed');
      dispatch({ type: types.LOAD_PICKLIST_FAILED, picklistType: PICKLIST_OPTIONS.STOP });
    }
    return stops;
  };
}

export function loadAssetLevelsPicklist(assetId) {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_PICKLIST, picklistType: PICKLIST_OPTIONS.ASSET_LEVELS_OPTIONS, isSearching: true });
    const assetLevels = await apiService.getAssetLevelsInfo({ assetId });
    dispatch(upsertAssetLevelsInfo(_.keyBy(assetLevels, 'id')));
    dispatch({
      type: types.LOAD_PICKLIST_SUCCESSFUL,
      picklistType: PICKLIST_OPTIONS.ASSET_LEVELS_OPTIONS,
      entities: assetLevels,
    });
  };
}

async function getAssetOptions({ taskType, searchString, stopId, id, areaIds, filterAssetLevels = false }) {
  const assetResponse = await apiService.getAssetsByTeamIdsAndAreaIds(
    [taskType.teamId],
    areaIds,
    searchString,
    ['well', 'tank', 'equipment', 'meter'],
    stopId,
    null,
    id,
    filterAssetLevels
  );
  const assetInflatedResponse = UtilityFunctions.inflateResponse(assetResponse);
  return (assetInflatedResponse || []).filter((asset) => !asset.isDeleted);
}

export function loadAssetPicklist({ taskType, searchString, stopId, id, filterAssetLevels = false }) {
  return async (dispatch, getState) => {
    dispatch({ type: types.LOADING_PICKLIST, picklistType: PICKLIST_OPTIONS.ASSET, isSearching: true });
    let assets = [];
    try {
      const { selectedField } = getState().appReducer;
      const accessToFieldAndAreas = getFieldsAndAreasAccessibleToUser(getState().appReducer.loggedInUser);
      const areaIds = accessToFieldAndAreas[selectedField.id] ?? [];
      if (taskType) {
        assets = await getAssetOptions({ taskType, searchString, stopId, id, areaIds, filterAssetLevels });
      }
      dispatch({ type: types.LOAD_PICKLIST_SUCCESSFUL, picklistType: PICKLIST_OPTIONS.ASSET, entities: assets });
    } catch (e) {
      logUtils.logError(e, 'Asset Loading Failed');
      dispatch({ type: types.LOAD_PICKLIST_FAILED, picklistType: PICKLIST_OPTIONS.ASSET });
    }
    return assets;
  };
}

export function clearPicklist(picklistType) {
  return async (dispatch) => {
    dispatch({ type: types.LOAD_PICKLIST_SUCCESSFUL, picklistType, entities: [] });
  };
}

export function clearParentTaskTemplateItem() {
  return async (dispatch) => {
    dispatch({
      type: types.CLEAR_PREFERRED_LOCATION_PARENT_TASK_TEMPLATE_ITEM,
    });
  };
}

export function removeItemFromParentTaskTemplate(workflowStepId) {
  return async (dispatch, getState) => {
    const parentTaskTemplateItems = getState().manageTaskFormReducer.parentTaskTemplate.items;
    const parentTaskTemplateItemsCopy = JSON.parse(JSON.stringify(parentTaskTemplateItems));
    const stepIndex = parentTaskTemplateItemsCopy
      .map((item) => item.originalItem.workflowStepId)
      .indexOf(workflowStepId);
    if (stepIndex > -1) {
      parentTaskTemplateItemsCopy.splice(stepIndex, 1);
      dispatch({
        type: types.LOADED_PARENT_TASK_TEMPLATE_SUCCESSFUL,
        parentTaskTemplateItems: parentTaskTemplateItemsCopy,
      });
    }
  };
}

export function loadPreferredLocationsAndAssigneeForParentTaskTemplateItem(workflowStepIdAndAssetIdData) {
  return async (dispatch) => {
    if (_.size(workflowStepIdAndAssetIdData)) {
      const workflowStepIdAndAssetIdDataClone = _.cloneDeep(workflowStepIdAndAssetIdData);
      dispatch({
        type: types.LOADING_PREFERRED_LOCATION_PARENT_TASK_TEMPLATE_ITEM,
        workflowStepIdAndAssetIdData,
        isSearching: true,
        isLoading: true,
      });
      try {
        const assetIds = _.uniq(workflowStepIdAndAssetIdData.map(({ assetId }) => assetId));
        const taskTypeIds = _.uniq(workflowStepIdAndAssetIdData.map(({ taskTypeId }) => taskTypeId));
        const taskTypes = await apiService.getTaskTypesByIds(taskTypeIds);
        const taskTypesIdMap = _.keyBy(taskTypes, 'id');
        const assets = await apiService.getAssetsByIds(assetIds);
        const stopIds = (assets || []).filter((asset) => asset.type !== 'stop').map((asset) => asset.stopId);
        let stopDict = {};
        if (_.size(stopIds)) {
          const stops = await apiService.getAssetsByIds(stopIds);
          stopDict = _.keyBy(stops, 'id');
        }
        const assetDict = _.keyBy(assets, 'id');
        for (const val of workflowStepIdAndAssetIdDataClone) {
          const reqAsset = assetDict[val.assetId];
          const reqStop = stopDict[_.get(reqAsset, 'stopId')];
          if (reqAsset) {
            val.assets = [reqAsset];
            val.assetId = reqAsset.id;
            const { assigneeOptions, equipmentOptions } =
              await TaskUtilities.getAllowedAssigneeAndEquipmentOptionsForTemplateItem({
                asset: reqAsset,
                taskType: taskTypesIdMap[val.taskTypeId],
              });
            val.assigneeOptions = assigneeOptions;
            val.equipmentOptions = equipmentOptions;
          }
          if (reqAsset && reqAsset.type !== 'stop' && reqStop) {
            val.selectedStop = reqStop;
          }
        }

        dispatch({
          type: types.LOADED_PREFERRED_LOCATION_PARENT_TASK_TEMPLATE_ITEM_SUCCESSFUL,
          picklistType: PICKLIST_OPTIONS.ASSET,
          workflowStepIdAndAssetIdData: workflowStepIdAndAssetIdDataClone,
          isSearching: false,
          isLoading: false,
        });
      } catch (e) {
        dispatch({
          type: types.LOADING_PREFERRED_LOCATION_PARENT_TASK_TEMPLATE_ITEM,
          workflowStepIdAndAssetIdData,
          isSearching: false,
          isLoading: false,
        });
        logUtils.logError(e, 'Parent Task Template Item Asset Loading Failed');
      }
    } else {
      clearParentTaskTemplateItem()(dispatch);
    }
  };
}

export function loadParentTaskTemplateItemAssests({ taskTypeId, searchString, workflowStepId }) {
  return async (dispatch, getState) => {
    let assets = [];
    dispatch({
      type: types.UPDATE_PARENT_TASK_TEMPLATE_ITEM,
      workflowStepId,
      objToMerge: {
        assetOptions: {
          isLoading: true,
          isSearching: true,
          items: [],
        },
      },
    });
    try {
      const { selectedField } = getState().appReducer;
      const { taskTypes = [] } = getState().taskTypeReducer;
      const accessToFieldAndAreas = getFieldsAndAreasAccessibleToUser(getState().appReducer.loggedInUser);
      const areaIds = accessToFieldAndAreas[selectedField.id] ?? [];
      const taskType = taskTypes.find((tt) => tt.id === taskTypeId);
      if (taskType && searchString) {
        const assetResponse = await apiService.getAssetsByTeamIdsAndAreaIds([taskType.teamId], areaIds, searchString);
        assets = UtilityFunctions.inflateResponse(assetResponse);
        assets = (assets || []).filter((asset) => !asset.isDeleted);
      }
      const picklistOptions = assets.map((asset) => ({
        key: asset.id,
        value: asset.id,
        text: getPicklistOptionText(PICKLIST_OPTIONS.ASSET)(asset),
        originalobject: asset,
      }));
      dispatch({
        type: types.UPDATE_PARENT_TASK_TEMPLATE_ITEM,
        workflowStepId,
        objToMerge: {
          assetOptions: {
            items: picklistOptions,
            isLoading: false,
            isSearching: false,
          },
        },
        refKey: 'assetId',
      });
    } catch (e) {
      logUtils.logError(e, 'Parent Task Template Item Asset Loading Failed');
    }
  };
}

export function loadAssetCriteriaTemplate(taskType) {
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING_ASSET_CRITERIA,
    });
    try {
      const { selectedField, allAreas } = getState().appReducer;
      const accessToFieldAndAreas = getFieldsAndAreasAccessibleToUser(getState().appReducer.loggedInUser);
      const areaIds = accessToFieldAndAreas[selectedField.id] ?? [];
      const allAreasMap = _.keyBy(allAreas, 'id');
      const { teamId, fieldId } = taskType;
      if (teamId) {
        const areasForCriteriaDropdown = areaIds
          .filter((id) => {
            const { teams = [] } = allAreasMap[id] || {};
            return (teams || []).filter((item) => !item.isDeleted && item.teamId === teamId).length;
          })
          .map((id) => allAreasMap[id]);
        const areasOptions = UtilityFunctions.getPickListOptions(areasForCriteriaDropdown);
        const areaIdsSelected = areasOptions.map((item) => item.key);
        dispatch({
          type: types.LOAD_ASSET_CRITERIA_SUCCESSFUL,
          info: {
            areasOptions,
            areaIds: areaIdsSelected,
            typesOptions: Object.values(ASSET_TYPES),
            types: [], // Object.values(ASSET_TYPES).map((item) => item.value),
            allAreaIds: areasOptions.map((item) => item.key),
          },
        });
        this.loadAssigneePicklist(null, taskType, fieldId, areaIdsSelected);
      }
    } catch (e) {
      dispatch({
        type: types.LOAD_ASSET_CRITERIA_FAILED,
      });
      logUtils.logError(e, 'Loading Asset Criteria failed');
    }
  };
}

export function clearCriteriaTemplate() {
  return async (dispatch) => {
    dispatch({
      type: types.LOAD_ASSET_CRITERIA_FAILED,
    });
  };
}

export function updateAssetCriteriaTemplateInfo(info) {
  return async (dispatch) => {
    try {
      dispatch({
        type: types.LOAD_ASSET_CRITERIA_SUCCESSFUL,
        info,
      });
    } catch (e) {
      dispatch({
        type: types.LOAD_ASSET_CRITERIA_FAILED,
      });
      logUtils.logError(e, 'update Asset Criteria Info Failed');
    }
  };
}

export async function getAssetsForAssetCriteriaWrapper(info) {
  const inputObj = TaskUtilities.getAssetCriteriaRequestObj(info);

  const assetResponse = await apiService.getAssetsByAssetsCriteria(inputObj);
  const assets = UtilityFunctions.inflateResponse(assetResponse);
  return assets;
}

export function searchAssetsForAssetCriteria({ taskType, searchString, dropdownFor }) {
  return async (dispatch, getState) => {
    const { assetCriteriaTemplate } = getState().manageTaskFormReducer;
    const { info = {} } = assetCriteriaTemplate || {};

    const key = dropdownFor === 'stop' ? 'stopSearchInfo' : 'locationSearchInfo';
    const assetTypesToSearch =
      dropdownFor === 'stop' ? [ASSET_TYPES.STOP.key] : Object.values(ASSET_TYPES).map((item) => item.value);
    const stopsToSearch = ''; // dropdownFor === 'stop' ? '' : info.stopIds || [];
    const areaIds = (dropdownFor === 'stop' ? info.areaIds : info.allAreaIds) || [];

    let assets = [];
    dispatch({
      type: types.LOAD_ASSET_CRITERIA_SUCCESSFUL,
      info: {
        [key]: {
          isLoading: true,
          items: info[key]?.selectedItems || [],
          selectedItems: info[key]?.selectedItems || [],
        },
      },
    });
    try {
      if (taskType && searchString) {
        const assetResponse = await apiService.getAssetsByTeamIdsAndAreaIds(
          [taskType.teamId],
          areaIds,
          searchString,
          assetTypesToSearch,
          stopsToSearch
        );
        assets = UtilityFunctions.inflateResponse(assetResponse);
        assets = (assets || []).filter((asset) => !asset.isDeleted);
      }
      const options = assets.map((asset) => ({
        key: asset.id,
        value: asset.id,
        text: getPicklistOptionText(PICKLIST_OPTIONS.ASSET)(asset),
        originalobject: asset,
      }));
      const picklistOptions = Object.values(_.keyBy([...(info[key]?.selectedItems || []), ...options], 'key'));

      dispatch({
        type: types.LOAD_ASSET_CRITERIA_SUCCESSFUL,
        info: {
          [key]: {
            isLoading: false,
            items: picklistOptions,
            selectedItems: info[key]?.selectedItems || [],
          },
        },
      });
    } catch (e) {
      logUtils.logError(e, 'search failed');
    }
  };
}

export function getAssetsForAssetCriteria() {
  return async (dispatch, getState) => {
    const { assetCriteriaTemplate } = getState().manageTaskFormReducer;
    const { info = {} } = assetCriteriaTemplate || {};

    dispatch({
      type: types.LOAD_ASSET_CRITERIA_SUCCESSFUL,
      info: {
        previewInfo: {
          isLoading: true,
          value: '',
        },
      },
    });

    try {
      const assets = await getAssetsForAssetCriteriaWrapper(info);
      dispatch({
        type: types.LOAD_ASSET_CRITERIA_SUCCESSFUL,
        info: {
          previewInfo: {
            isLoading: false,
            value: assets
              .map((item) => getPicklistOptionText(PICKLIST_OPTIONS.ASSET)(item))
              .sort((a, b) => a.localeCompare(b))
              .join(', '),
            valueSummary: getAssetsPreviewInfo(assets),
          },
        },
      });
    } catch (e) {
      dispatch({
        type: types.LOAD_ASSET_CRITERIA_SUCCESSFUL,
        info: {
          previewInfo: {
            isLoading: false,
            value: '',
            valueSummary: `Incorrect criteria`,
          },
        },
      });
      logUtils.logError(e, 'load preview failed');
    }
  };
}

export function updateParentTaskTemplateItemOnAssetChange({
  assetId,
  workflowStepId,
  asset,
  taskType,
  stopId,
  assetOptionsItems = [],
}) {
  return async (dispatch, getState) => {
    // change in asset will triggger, selected stop, assignee and equipmentOptions change

    let selectedStop = null;
    let assigneeOptions = [];
    let equipmentOptions = [];
    const parentTaskTemplateItems = getState().manageTaskFormReducer.parentTaskTemplate.items;
    const taskTypeOptions = getState().manageTaskFormReducer[PICKLIST_OPTIONS.TASK_TYPE];
    const taskTypesDict = _.keyBy(
      (taskTypeOptions?.items || []).map((item) => item.originalobject).filter((item) => item),
      'id'
    );

    dispatch({
      type: types.UPDATE_PARENT_TASK_TEMPLATE_ITEM,
      objToMerge: {
        assetId,
      },
      workflowStepId,
    });

    for (const item of parentTaskTemplateItems) {
      const { originalItem } = item;
      if (originalItem.sameLocationAs === workflowStepId) {
        // This is needed as options in the other dropdown might be different
        dispatch({
          type: types.UPDATE_PARENT_TASK_TEMPLATE_ITEM,
          objToMerge: {
            assetId,
            assetOptions: {
              items: assetOptionsItems,
              isLoading: false,
              isSearching: false,
            },
          },
          workflowStepId: originalItem.workflowStepId,
        });
      }
    }

    if (stopId) {
      const stopResponse = await apiService.getAsset(stopId);
      const stop = _.get(stopResponse, 'data.getAsset');
      if (!stop) {
        throw stopResponse;
      }
      const projection = ['latitude', 'stopId', 'areas', 'type', 'isDeleted', 'name', 'id', 'longitude'];
      selectedStop = _.pick(stop, projection);
    }

    dispatch({
      type: types.UPDATE_PARENT_TASK_TEMPLATE_ITEM,
      objToMerge: { selectedStop },
      workflowStepId,
      refKey: 'selectedStop',
    });

    // update this step assignee
    if (taskType && asset) {
      const res = await TaskUtilities.getAllowedAssigneeAndEquipmentOptionsForTemplateItem({
        asset,
        taskType,
      });
      assigneeOptions = res.assigneeOptions;
      equipmentOptions = res.equipmentOptions;
    }

    dispatch({
      type: types.LOADED_PARENT_TASK_TEMPLATE_ITEM_ASSIGNEE_SUCCESSFUL,
      assigneeOptions,
      equipmentOptions,
      workflowStepId,
    });

    for (const item of parentTaskTemplateItems) {
      const { originalItem } = item;
      if (originalItem.immediateNextTo === workflowStepId || originalItem.sameAssigneeAs === workflowStepId) {
        const otherTaskType = taskTypesDict[originalItem.taskTypeId];
        if (otherTaskType && asset) {
          const res = await TaskUtilities.getAllowedAssigneeAndEquipmentOptionsForTemplateItem({
            asset,
            taskType: otherTaskType,
          });
          assigneeOptions = res.assigneeOptions;
          equipmentOptions = res.equipmentOptions;
        }

        dispatch({
          type: types.LOADED_PARENT_TASK_TEMPLATE_ITEM_ASSIGNEE_SUCCESSFUL,
          assigneeOptions,
          equipmentOptions,
          workflowStepId: originalItem.workflowStepId,
        });
      }
    }
  };
}

export function updateParentTaskTemplateItemOnKeyChange({ key, keyValue, workflowStepId }) {
  // Generic method for any key change which does not need much processing
  return async (dispatch) => {
    dispatch({
      type: types.UPDATE_PARENT_TASK_TEMPLATE_ITEM,
      workflowStepId,
      objToMerge: { [key]: keyValue },
      refKey: key,
    });
  };
}

export function updateAllParentTaskTemplateItemsWithKey({ key, keyValue }) {
  // Generic method for any key update on all template items
  return async (dispatch) => {
    if (key) {
      dispatch({
        type: types.UPDATE_PARENT_TASK_TEMPLATE,
        objToMerge: { [key]: keyValue },
      });
    }
  };
}

export function loadAssigneePicklist(asset, taskType, fieldId, areaIdsSelected) {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_PICKLIST, picklistType: PICKLIST_OPTIONS.ASSIGNEE });
    try {
      const areaIds = areaIdsSelected || asset.areas.filter((a) => !a.isDeleted).map((a) => a.areaId);
      const teamIds = [taskType.teamId];
      const userResponse = await apiService.getUsersByTeamIdsAndAreaIds(teamIds, areaIds, fieldId);
      if (!_.get(userResponse, 'data.rpcService.success')) {
        throw userResponse;
      }
      let assignees = _.get(userResponse, 'data.rpcService.output');
      assignees = JSON.parse(assignees);
      const reqVendorIds = assignees.map((val) => val.vendorId).filter((val) => val);
      const contactIds = assignees
        .map((val) => {
          if (val.defaultContact) {
            return val.defaultContact;
          }
          if (val?.contacts?.length) {
            return val.contacts[0];
          }
          return null;
        })
        .filter((val) => val);
      const [vendors, contacts] = await Promise.all([
        apiService.getEntitiesByIds(_.uniq(reqVendorIds), 'vendor'),
        apiService.getContactsByContactIds(_.uniq(contactIds), 'vendor'),
      ]);
      const vendorDict = _.keyBy(vendors, 'id');
      const contactsDict = _.keyBy(contacts, 'id');
      assignees = assignees.filter((assignee) => TaskUtilities.isUserCapableForTask(assignee, taskType));
      assignees = assignees.map((a) => {
        // changes made for custom attribute and the key has to be vendor
        if (a.vendorId) {
          a.vendor = vendorDict[a.vendorId];
        }
        if (a?.contacts?.length) {
          if (a.defaultContact) {
            a.contact = contactsDict[a.defaultContact];
          } else {
            const [contactId] = a.contacts;
            a.contact = contactsDict[contactId];
          }
        }

        a.name = `${a.firstName} ${a.lastName}`;
        return a;
      });
      dispatch({ type: types.LOAD_PICKLIST_SUCCESSFUL, picklistType: PICKLIST_OPTIONS.ASSIGNEE, entities: assignees });
      return assignees;
    } catch (e) {
      logUtils.logError(e, 'Assignees Loading Failed');
      dispatch({ type: types.LOAD_PICKLIST_FAILED, picklistType: PICKLIST_OPTIONS.ASSIGNEE });
      return [];
    }
  };
}

function getTaskDefaultStatusForUser(user) {
  const accessOptions = getAccessOptionsForResourceAndUser({
    entityAccessType: ENTITY_ACCESS_TYPE.CREATE,
    accessOptionName: ACCESS_OPTIONS.STATUS.name,
    resourceType: RESOURCE_TYPE.ENTITY,
    resource: RESOURCES.ENTITY.TASK,
    user,
  });
  if (accessOptions.includes(ACCESS_OPTIONS.STATUS.options.ALL_STATUS)) {
    return STATUS_LIST.OPEN.key;
  }
  if (accessOptions.includes(ACCESS_OPTIONS.STATUS.options.DRAFT_STATUS)) {
    return STATUS_LIST.DRAFT.key;
  }
  console.warn('invalid access options of status for create task');
  return STATUS_LIST.OPEN.key;
}

export function getAsset(assetId) {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_PICKLIST, picklistType: PICKLIST_OPTIONS.ASSET });
    let assets = [];
    try {
      if (assetId) {
        const assetResponse = await apiService.getAsset(assetId);
        const asset = _.get(assetResponse, 'data.getAsset');
        if (!asset) {
          throw assetResponse;
        }
        const projection = [
          'latitude',
          'stopId',
          'areas',
          'type',
          'isDeleted',
          'name',
          'id',
          'longitude',
          'customAttributes',
          'attachments',
          'hierarchy',
        ];
        const result = _.pick(asset, projection);
        if (result) {
          loadAssetLevelsPicklist(asset.id)(dispatch);
        }
        result.customAttributes = UtilityFunctions.parseJSONStringToObject(result.customAttributes);
        assets = [result];
      }
      dispatch({ type: types.LOAD_PICKLIST_SUCCESSFUL, picklistType: PICKLIST_OPTIONS.ASSET, entities: assets });
    } catch (e) {
      logUtils.logError(e, 'Location Loading Failed');
      dispatch({ type: types.LOAD_PICKLIST_FAILED, picklistType: PICKLIST_OPTIONS.ASSET });
    }
    return assets;
  };
}

export function getStop(stopId) {
  return async (dispatch) => {
    dispatch({ type: types.GET_STOP });
    dispatch({ type: types.LOADING_PICKLIST, picklistType: PICKLIST_OPTIONS.STOP });
    let result = {};
    try {
      if (stopId) {
        const stopResponse = await apiService.getAsset(stopId);
        const stop = _.get(stopResponse, 'data.getAsset');
        if (!stop) {
          throw stopResponse;
        }
        const projection = [
          'latitude',
          'stopId',
          'areas',
          'type',
          'isDeleted',
          'name',
          'id',
          'longitude',
          'customAttributes',
          'attachments',
        ];
        result = _.pick(stop, projection);
        result.customAttributes = UtilityFunctions.parseJSONStringToObject(result.customAttributes);
      }
      dispatch({ type: types.LOAD_PICKLIST_SUCCESSFUL, picklistType: PICKLIST_OPTIONS.STOP, entities: [result] });
      dispatch({ type: types.GET_STOP_SUCCESS, stop: result });
      return result;
    } catch (e) {
      dispatch({ type: types.GET_STOP_FAILED });
      logUtils.logError(e, 'Stop fetching Failed');
    }
    return null;
  };
}

function createSchemaFromTaskGlobalAttributes(
  taskGlobalAttributes,
  isChildTask = '',
  isUpdate,
  isBulkEdit = false,
  loggedInUser,
  rollupGlobalAttributes = []
) {
  const schema = {};
  // JOYN-4825 isUpdate added as requireedOnCreation is not mandatory while updating the attribute

  // JOYN2-4568 requiredOnCreation functionality is handled by making it mandatory on task creation

  // isBulkEdit as  isMandatory is not required on bulkEdit

  // either isUpdate should not be empty and isBulkEdit should be true for the field to be not mandatory
  const disabledGlobalAttribute = determineIfUserHasFieldsDisabled({
    resource: RESOURCES.ENTITY.TASK,
    entityAccessType: !_.isEmpty(isUpdate) || isBulkEdit ? ENTITY_ACCESS_TYPE.UPDATE : ENTITY_ACCESS_TYPE.CREATE,
    field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_GLOBAL_ATRIBUTES,
    user: loggedInUser,
  });
  if (taskGlobalAttributes && taskGlobalAttributes.length > 0) {
    taskGlobalAttributes.forEach((taskGlobalAttribute, index) => {
      let isDisabled = !!isChildTask;
      if (isChildTask) {
        if (rollupGlobalAttributes.indexOf(taskGlobalAttribute.id) > -1) {
          isDisabled = false;
        }
      } else if (rollupGlobalAttributes.indexOf(taskGlobalAttribute.id) > -1) {
        isDisabled = true;
      }

      schema[`g_${taskGlobalAttribute.attributeName}`] = {
        name: taskGlobalAttribute.attributeName,
        displayName: taskGlobalAttribute.attributeDisplayName,
        isMandatory: !_.isEmpty(isUpdate) || isBulkEdit ? false : taskGlobalAttribute.requiredOnCreation,
        sequence: index,
        type: taskGlobalAttribute.attributeType,
        picklistId: taskGlobalAttribute.picklistId,
        requiredOnResolve: taskGlobalAttribute.requiredOnResolve,
        showDescription: taskGlobalAttribute.showDescription,
        onChange: 'onGlobalAttributeValueChange',
        isChildTask: !!isChildTask,
        disabled: disabledGlobalAttribute || isDisabled,
        parentPickListIds: taskGlobalAttribute.parentPickListIds,
        mappingId: taskGlobalAttribute.mappingId,
        id: taskGlobalAttribute.id,
        metadataInfo: taskGlobalAttribute.metadataInfo,
      };
    });
  }
  return schema;
}

function findCustomAndGlobalPicklistsForSchema(schema) {
  const customPicklistSchema = {};
  for (const [attributeName, attributeObj] of Object.entries(schema)) {
    if (typeof attributeObj !== 'object') continue;
    if (
      (attributeName.startsWith('c_') || attributeName.startsWith('g_')) &&
      (attributeObj.type === ATTRIBUTE_TYPE.PICKLIST || attributeObj.type === ATTRIBUTE_TYPE.METADATA_DYNAMIC_LIST)
    ) {
      customPicklistSchema[attributeName] = attributeObj;
    }
  }
  return customPicklistSchema;
}

function addSchemaRelatedPropertiesToCustomAndGlobalAttributes(schema, getState, isCreate) {
  const { picklistMappings } = getState().picklistMappingReducer;
  const { picklists } = getState().picklistReducer;
  const { loggedInUser } = getState().appReducer;

  const picklistDict = _.keyBy(picklists, 'id');
  for (const [attributeName, attributeObj] of Object.entries(schema)) {
    if (typeof attributeObj !== 'object') continue;
    if (attributeName.startsWith('c_')) {
      attributeObj.id = attributeName;
      attributeObj.path = `data.${attributeName}`;
      attributeObj.onChange = 'onCustomPicklistValueChange';
    }
    if (attributeName.startsWith('g_')) {
      attributeObj.path = `globalAttributes.${attributeObj.name}`;
    }
  }
  const picklistSchema = findCustomAndGlobalPicklistsForSchema(schema);
  const disabledGlobalAttribute = determineIfUserHasFieldsDisabled({
    resource: RESOURCES.ENTITY.TASK,
    entityAccessType: isCreate ? ENTITY_ACCESS_TYPE.CREATE : ENTITY_ACCESS_TYPE.UPDATE,
    field: ACCESS_OPTIONS.DISABLED_FIELD.options.TASK_GLOBAL_ATRIBUTES,
    user: loggedInUser,
  });
  Object.keys(picklistSchema).forEach((attributeName) => {
    picklistSchema[attributeName].optionsVariableName = `customPicklistOptions.${attributeName}`;
    picklistSchema[attributeName].options = fetchOptionsForPicklist.bind(
      picklistSchema[attributeName],
      picklistMappings,
      picklistDict,
      attributeName,
      picklistSchema
    );
    if (attributeName.startsWith('c_')) {
      picklistSchema[attributeName].path = buildPathFunctionForCustomAttributePicklist(attributeName);
      picklistSchema[attributeName].setValue = buildSetValueFunctionForCustomAttributePicklist(
        attributeName,
        picklistSchema[attributeName]
      );
      picklistSchema[attributeName].disabled = disabledFunctionForPicklist.bind(picklistSchema[attributeName]);
    } else if (attributeName.startsWith('g_')) {
      if (disabledGlobalAttribute) {
        picklistSchema[attributeName].disabled = true;
      } else {
        picklistSchema[attributeName].disabled = disabledFunctionForPicklist.bind(picklistSchema[attributeName]);
      }
      picklistSchema[attributeName].path = buildPathFunctionForGlobalAttributePicklist(
        picklistSchema[attributeName].name
      );
      picklistSchema[attributeName].setValue = buildSetValueFunctionForGlobalAttributePicklist(
        attributeName,
        picklistSchema[attributeName]
      );
    }
  });
  return picklistSchema;
}

function showErrorForNotFoundPicklist(picklistsResponse, customPicklistAttributeListGroupedByPicklistId) {
  const picklistIdsFoundInResponse = picklistsResponse.map((picklist) => picklist.id);
  const picklistIdsForWhichRequestWasMade = Object.keys(customPicklistAttributeListGroupedByPicklistId);
  const picklistIdsForWhichPicklistNotFound = _.difference(
    picklistIdsForWhichRequestWasMade,
    picklistIdsFoundInResponse
  );
  if (picklistIdsForWhichPicklistNotFound.length > 0) {
    const picklistDisplayNamesForWhichPicklistNotFound = picklistIdsForWhichPicklistNotFound.flatMap((picklistId) =>
      customPicklistAttributeListGroupedByPicklistId[picklistId].map(
        (picklistAttribute) => picklistAttribute.displayName
      )
    );
    toastr.error(`Picklists ${picklistDisplayNamesForWhichPicklistNotFound.join(', ')} not found`);
  }
}

function handlePicklistResponse(dispatch, picklistResponse, customPicklistAttributeList, customPicklistOptions) {
  const picklistResponseKeyedByPicklistId = _.keyBy(picklistResponse, 'id');
  const picklistOptionsAttributeNameObjectList = [];
  customPicklistAttributeList.forEach((picklistAttribute) => {
    picklistOptionsAttributeNameObjectList.push({
      attributeName: picklistAttribute.attributeName,
      picklistOptions: Object.values(
        _.get(picklistResponseKeyedByPicklistId, `${picklistAttribute.picklistId}.options`) || {}
      ),
    });
  });
  const customPicklistOptionsList = getcustomPicklist(
    picklistOptionsAttributeNameObjectList,
    _.cloneDeep(customPicklistOptions)
  );

  dispatch({
    type: types.LOADED_PICKLIST_FOR_CUSTOM_ATTRIBUTE_SUCCESSFULLY,
    customPicklistOptionsList,
  });
  return customPicklistOptionsList;
}

async function loadOptionsForCustomPicklists(dispatch, schema, getState) {
  const { customPicklistOptions } = getState();
  const customPicklistAttributesObject = findCustomAndGlobalPicklistsForSchema(schema);
  const customPicklistAttributeNames = Object.keys(customPicklistAttributesObject);
  if (customPicklistAttributeNames.length) {
    dispatch({ type: types.LOADING_PICKLIST_FOR_CUSTOM_ATTRIBUTE, attributeNames: customPicklistAttributeNames });
    try {
      const customPicklistAttributeList = customPicklistAttributeNames
        .map((attributeName) => ({
          ...customPicklistAttributesObject[attributeName],
          attributeName,
        }))
        .filter((attr) => attr.type === ATTRIBUTE_TYPE.PICKLIST);
      const customPicklistAttributeListGroupedByPicklistId = _.groupBy(customPicklistAttributeList, 'picklistId');
      const picklistIds = Object.keys(customPicklistAttributeListGroupedByPicklistId);
      const picklists = await apiService.getPicklistByPicklistIds(picklistIds);

      showErrorForNotFoundPicklist(picklists, customPicklistAttributeListGroupedByPicklistId);
      const customPicklistOptionList = handlePicklistResponse(
        dispatch,
        picklists,
        customPicklistAttributeList,
        customPicklistOptions
      );
      return customPicklistOptionList;
    } catch (e) {
      logUtils.logError(e, 'Custom Picklists Loading Failed');
      dispatch({
        type: types.LOADED_PICKLIST_FOR_CUSTOM_ATTRIBUTE_FAILED,
        attributeNames: customPicklistAttributeNames,
      });
    }
  }
  return customPicklistOptions;
}

function getDefaultValuesOfGlobalAttributes(taskGlobalAttributes) {
  const globalAttributeDefaultValues = {};
  if (taskGlobalAttributes) {
    taskGlobalAttributes.forEach((taskGlobalAttribute) => {
      globalAttributeDefaultValues[taskGlobalAttribute.attributeName] = taskGlobalAttribute.defaultValue;
    });
  }
  return globalAttributeDefaultValues;
}

export function loadCreateTaskForm(params, allTasks) {
  return (dispatch, getState) => {
    if (params.parentLinkedTaskId) {
      // eslint-disable-next-line no-use-before-define
      loadCreateLinkTaskForm(params, allTasks)(dispatch, getState);
      return;
    }
    const { loggedInUser } = getState().appReducer;
    const taskGlobalAttributes = (getState().globalAttributeReducer.attributes || []).filter(
      (attr) => attr.entityType === 'task'
    );
    const globalSchema = createSchemaFromTaskGlobalAttributes(taskGlobalAttributes, '', null, null, loggedInUser);
    const task = _.cloneDeep({ ...NEW_TASK, startTime: moment().add(1, 'hour').startOf('hour').toISOString() });
    task.globalAttributes = getDefaultValuesOfGlobalAttributes(taskGlobalAttributes);
    task.status = getTaskDefaultStatusForUser(loggedInUser);
    const defaultSchema = _.cloneDeep(DEFAULT_TASK_SCHEMA);
    const schema = { ...defaultSchema, ...globalSchema };
    addSchemaRelatedPropertiesToCustomAndGlobalAttributes(schema, getState, true);
    loadOptionsForCustomPicklists(dispatch, schema, getState);
    const { fieldId } = params;
    const { selectedTaskTypeGroups } = getState().appReducer;
    loadTaskTypePicklist({ fieldId, isCreate: true, selectedTaskTypeGroups })(dispatch, getState);
    dispatch({ type: types.LOAD_CREATE_FORM_SCHEMA_AND_VALUES, task, schema });
  };
}

function loadCreateLinkTaskForm(params, allTasks) {
  return (dispatch, getState) => {
    const { loggedInUser } = getState().appReducer;
    const taskGlobalAttributes = (getState().globalAttributeReducer.attributes || []).filter(
      (attr) => attr.entityType === 'task'
    );
    const globalSchema = createSchemaFromTaskGlobalAttributes(taskGlobalAttributes, '', null, null, loggedInUser);
    const task = _.cloneDeep({ ...NEW_TASK, startTime: moment().add(1, 'hour').startOf('hour').toISOString() });
    task.globalAttributes = getDefaultValuesOfGlobalAttributes(taskGlobalAttributes);
    task.status = getTaskDefaultStatusForUser(loggedInUser);
    const defaultSchema = _.cloneDeep(DEFAULT_TASK_SCHEMA);
    const schema = { ...defaultSchema, ...globalSchema };
    addSchemaRelatedPropertiesToCustomAndGlobalAttributes(schema, getState, true);
    loadOptionsForCustomPicklists(dispatch, schema, getState);
    const parentLinkedTask = allTasks.find((t) => t.id === params.parentLinkedTaskId);
    if (parentLinkedTask) {
      const {
        asset: {
          id: assetIdOfParentLinkedTask,
          stop: { id: stopIdOfParentLinkedTask, areas },
          type,
        },
      } = parentLinkedTask;
      const areasParamForTaskType = areas.filter((a) => !a.isDeleted).map((a) => a.areaId);
      const { selectedTaskTypeGroups } = getState().appReducer;
      loadTaskTypePicklist({
        areas: areasParamForTaskType,
        isCreate: true,
        loadForLinkedTask: true,
        selectedTaskTypeGroups,
      })(dispatch, getState);
      dispatch(getStop(stopIdOfParentLinkedTask));
      if (type !== 'stop') {
        dispatch(getAsset(assetIdOfParentLinkedTask));
      }

      task.assetId = assetIdOfParentLinkedTask;
      task.asset = _.clone(parentLinkedTask.asset);
      dispatch({ type: types.LOAD_CREATE_LINK_TASK_FORM_SCHEMA_AND_VALUES, task, schema, parentLinkedTask });
    } else {
      logUtils.logError(
        new Error(`Parent linked task ${params.parentLinkedTaskId} not found in all tasks`),
        'Parent Linked Task Not Found'
      );
      delete params.parentLinkedTaskId;
      loadCreateTaskForm(params, allTasks)(dispatch, getState);
    }
  };
}

async function getTasksByIds(taskIds) {
  if (!taskIds || taskIds.length === 0) {
    return [];
  }
  const tasks = await apiService.getTasksByTaskIds(taskIds);
  return tasks;
}

async function loadDependentTasks(dispatch, task, allTasks) {
  if (task && task.dependsOn && task.dependsOn.length) {
    dispatch({ type: types.LOADING_DEPENDENT_TASKS_SUCCESSFUL });
    try {
      const dependsOnTasksFoundInStore = allTasks.filter((t) => task.dependsOn.includes(t.id));
      const dependsOnTaskIdsNotFoundInStore = _.difference(
        task.dependsOn,
        dependsOnTasksFoundInStore.map((t) => t.id)
      );
      let dependsOnTasks = [...dependsOnTasksFoundInStore];
      if (dependsOnTaskIdsNotFoundInStore && dependsOnTaskIdsNotFoundInStore.length) {
        const tasks = await getTasksByIds(dependsOnTaskIdsNotFoundInStore);
        dependsOnTasks = [...dependsOnTasks, ...tasks];
      }
      const dependentTaskObjects = dependsOnTasks.map((t) => {
        const { asset, taskType, assignee, assigneeIds = [] } = t;
        const assigneeObject = UtilityFunctions.parseJSONStringToObject(assignee);
        let assigneeNames = [];
        const filterAssigneeIds = assigneeIds.filter((val) => !val.isDeleted).map((val) => val.assigneeId);
        if (filterAssigneeIds?.length) {
          assigneeNames = filterAssigneeIds.map((val) => {
            return `${_.get(assigneeObject, `${val}.firstName`)} ${_.get(assigneeObject, `${val}.lastName`)}`;
          });
        }
        return {
          asset: asset.name,
          taskType: taskType.name,
          assignee: assigneeNames.join(', '),
        };
      });
      dispatch({ type: types.LOADED_DEPENDENT_TASKS_SUCCESSFUL, dependentTasks: dependentTaskObjects });
    } catch (e) {
      dispatch({ type: types.LOADED_DEPENDENT_TASKS_FAILED });
      logUtils.logError(e);
    }
  }
}

export async function loadLinkedTasks(dispatch, task, allTasks, loggedInUser) {
  if (task && task.linkedTaskIds && task.linkedTaskIds.length) {
    dispatch({ type: types.LOADING_LINKED_TASKS });
    try {
      const linkedTasksFoundInStore = allTasks.filter((t) => task.linkedTaskIds.includes(t));
      const linkedTaskIdsNotfoundInStore = _.difference(
        task.linkedTaskIds,
        linkedTasksFoundInStore.map((t) => t.id)
      );
      let linkedTasks = [...linkedTasksFoundInStore];
      if (linkedTaskIdsNotfoundInStore && linkedTaskIdsNotfoundInStore.length) {
        let tasks = await getTasksByIds(task.linkedTaskIds);
        tasks = tasks.filter((t) => TaskUtilities.shouldShowForLoggedInVendor(t.assigneeIds, loggedInUser));
        linkedTasks = [...linkedTasks, ...tasks];
      }
      linkedTasks = linkedTasks.filter((t) => !t.isDeleted);
      dispatch({ type: types.LOADED_LINKED_TASKS_SUCCESSFUL, linkedTasks });
    } catch (e) {
      dispatch({ type: types.LOADED_LINKED_TASKS_FAILED });
      logUtils.logError(e);
    }
  }
}

async function loadTaskTemplate(dispatch, task) {
  const { template = [] } = task;
  if (template && template.length) {
    dispatch({ type: types.LOADING_TASK_TEMPLATE });
    try {
      const taskTypeIds = template.map((item) => item.taskTypeId).filter((item) => item);
      const assetIds = template.map((item) => item.assetId).filter((item) => item);
      const taskTypes = await apiService.getTaskTypesByIds(taskTypeIds);
      const templateAssets = await apiService.getAssetsByIds(assetIds);
      const templateAssetsStopIds = templateAssets
        .filter((item) => item.stopId && item.id !== item.stopId) // filter assets which are not stops
        .map((item) => item.stopId);
      let templateAssetsStops = [];
      if (templateAssetsStopIds.length) {
        templateAssetsStops = await apiService.getAssetsByIds(templateAssetsStopIds);
      }
      const templateAssetsStopsMap = _.keyBy(templateAssetsStops, 'id');
      const allTeams = [];
      const formSections = [];
      const templateAssetsInfoMap = {};
      for (const item of templateAssets) {
        const { id, stopId, name } = item;
        if (!templateAssetsInfoMap[id]) {
          templateAssetsInfoMap[id] = {};
          templateAssetsInfoMap[id].assetName = name;
          if (stopId && id !== stopId) {
            templateAssetsInfoMap[id].stopName = templateAssetsStopsMap[stopId].name;
          } else {
            templateAssetsInfoMap[id].stopName = name;
          }
        }
      }
      const workflowData = convertDbWorkflowToWorkflowTableData({ workflowSteps: template });
      const templateInfoItems = getWorkflowTableData(
        workflowData,
        taskTypes,
        allTeams,
        formSections,
        templateAssetsInfoMap
      );
      dispatch({ type: types.LOADED_TASK_TEMPLATE_SUCCESSFUL, templateInfoItems });
    } catch (e) {
      dispatch({ type: types.LOADED_TASK_TEMPLATE_FAILED });
      logUtils.logError(e);
    }
  }
}

export function loadParentTaskTemplate(taskType, parentTaskId, task) {
  return async (dispatch, getState) => {
    try {
      let childTasksDictByWorkflowId = {};
      let parentTaskTemplateItems = [];
      let showEquipmentColumnForParentTemplate = false;
      let childTasks = [];
      let template = [];

      if (parentTaskId) {
        const res = await apiService.getChildTasksByParentTaskId(parentTaskId);
        childTasks = res.childTasks || [];
        childTasks.sort(({ taskNumber: taskNumber1 }, { taskNumber: taskNumber2 }) => {
          try {
            if (taskNumber1 && taskNumber2) {
              const taskNumber1Int = parseInt(taskNumber1.split('-').pop());
              const taskNumber2Int = parseInt(taskNumber2.split('-').pop());
              return taskNumber1Int - taskNumber2Int;
            }
          } catch {
            return 0;
          }
          return 0;
        });
        childTasksDictByWorkflowId = _.keyBy(childTasks, 'workflowStepId');
      }

      const { workflowVersions = [], publishedVersion } = taskType;
      const pulishedWorkflow = (workflowVersions || []).filter((item) => item.version === publishedVersion)[0];
      if (pulishedWorkflow) {
        const { workflowSteps = [] } = pulishedWorkflow;
        template = workflowSteps;
      }
      if (taskType.isDynamicParentChild) {
        template = UtilityFunctions.getTemplateForDynamicParentChild(taskType, childTasks, false);
      }

      if (task && parentTaskId && TaskUtilities.isTaskRecurring(task) && task.template?.length) {
        template = task.template || [];
      }
      let preferredLocationData = [];
      if (!taskType.isDynamicParentChild && parentTaskId && task?.asset) {
        preferredLocationData = TaskUtilities.computeWorkflowAndPreferredLocation(
          _.cloneDeep(taskType),
          _.cloneDeep(task.asset)
        );
      }
      if (template.length) {
        const preferredLocationDataDict = _.keyBy(preferredLocationData, 'workflowStepId');
        dispatch({ type: types.LOADING_PARENT_TASK_TEMPLATE });

        const taskTypeOptions = getState().manageTaskFormReducer[PICKLIST_OPTIONS.TASK_TYPE];
        const taskTypesIdMap = _.keyBy(
          (taskTypeOptions?.items || []).map((item) => item.originalobject).filter((item) => item),
          'id'
        );
        const taskTypeIds = template.map((item) => item.taskTypeId).filter((item) => item);
        showEquipmentColumnForParentTemplate = !!taskTypeIds.filter((id) => taskTypesIdMap[id]?.needEquipment).length;

        parentTaskTemplateItems = template.map((item) => {
          const childTask = childTasksDictByWorkflowId[item.workflowStepId] || {};
          const { basePriority, maxPriority, timeToNextPriority } = TaskUtilities.getPriorityTemplateSpecs(
            _.get(taskType, 'priorityTemplate')
          );
          const priorityOptions = TaskUtilities.getPriorityList(
            basePriority,
            maxPriority,
            _.get(taskType, 'priorityAlias')
          );
          const timeToNextProrityOptions = TaskUtilities.getTimeToNextPriorityOptions();
          const { assigneeIdsToEvaluate, equipmentIdToEvaluate } = TaskUtilities.getEquipmentIdAndAssigneeIdsToEvaluate(
            childTask.assigneeIds || item.assigneeIds || [],
            taskTypesIdMap[item.taskTypeId]?.needEquipment
          );
          return {
            originalItem: item,
            taskTypeName: `${taskTypesIdMap[item.taskTypeId].name} ${
              childTasksDictByWorkflowId[item.workflowStepId]
                ? ` [${childTasksDictByWorkflowId[item.workflowStepId].taskNumber}]`
                : ''
            }`,
            needEquipment: taskTypesIdMap[item.taskTypeId]?.needEquipment || false,
            assetId: childTask.assetId || item.assetId || preferredLocationDataDict[item.workflowStepId]?.assetId || '',
            priorityOptions,
            timeToNextProrityOptions,
            priority: childTask.priority || item.priority || _.get(priorityOptions, `${[0]}.value`),
            timeToNextPriority:
              childTask.timeToNextPriority ||
              item.timeToNextPriority ||
              timeToNextPriority ||
              _.get(timeToNextProrityOptions, `${[0]}.value`),
            assigneeIdsToEvaluate,
            equipmentIdToEvaluate,
            taskTypeChangeAllowed: item.taskTypeChangeAllowed,
            // sameAsParentAsset: false,
          };
        });
      }
      dispatch({
        type: types.LOADED_PARENT_TASK_TEMPLATE_SUCCESSFUL,
        parentTaskTemplateItems,
        showEquipmentColumnForParentTemplate,
        // parentTaskTemplateTaskTypesDict: taskTypesIdMap,
        childTasksDictByWorkflowId,
      });
      if (parentTaskId && parentTaskTemplateItems.length) {
        dispatch(
          loadPreferredLocationsAndAssigneeForParentTaskTemplateItem(
            parentTaskTemplateItems.map((item) => ({
              assetId: item.assetId,
              taskTypeId: item.originalItem.taskTypeId,
              workflowStepId: item.originalItem.workflowStepId,
              assigneeIdsToEvaluate: item.assigneeIdsToEvaluate,
              equipmentIdToEvaluate: item.equipmentIdToEvaluate,
            }))
          )
        );
      }
    } catch (e) {
      const message = e instanceof Error ? 'Loading Parent Task Template Failed' : e.message;
      dispatch({ type: types.LOADED_PARENT_TASK_TEMPLATE_FAILED });
      logUtils.logError(e, message);
      throw e;
    }
  };
}

export function addChildToParentTaskTemplate(taskType) {
  return async (dispatch, getState) => {
    try {
      const newTemplate = UtilityFunctions.getTemplateForDynamicParentChild(taskType, [], true);

      const taskTypeOptions = getState().manageTaskFormReducer[PICKLIST_OPTIONS.TASK_TYPE];

      const parentTaskTemplateItems = getState().manageTaskFormReducer.parentTaskTemplate.items; // existing items

      if (newTemplate.length) {
        const newTaskTemplateItems = newTemplate.map((item) => {
          const childTask = {};
          const { basePriority, maxPriority, timeToNextPriority } = TaskUtilities.getPriorityTemplateSpecs(
            _.get(taskType, 'priorityTemplate')
          );
          const priorityOptions = TaskUtilities.getPriorityList(
            basePriority,
            maxPriority,
            _.get(taskType, 'priorityAlias')
          );
          const timeToNextProrityOptions = TaskUtilities.getTimeToNextPriorityOptions();

          return {
            originalItem: item,
            taskTypeName: '',
            needEquipment: false,
            assetId: '',
            priorityOptions,
            timeToNextProrityOptions,
            priority: childTask.priority || _.get(priorityOptions, `${[0]}.value`),
            timeToNextPriority:
              childTask.timeToNextPriority || timeToNextPriority || _.get(timeToNextProrityOptions, `${[0]}.value`),
            assigneeIdsToEvaluate: [],
            equipmentIdToEvaluate: '',
            taskTypeOptionsToUse: (taskTypeOptions?.items || []).filter(
              (i) =>
                !i.originalobject.isParent &&
                !i.originalobject.isDynamicParentChild &&
                i.originalobject.fieldId === taskType.fieldId
            ),
            taskTypeChangeAllowed: true,

            // sameAsParentAsset: false,
          };
        });
        dispatch({
          type: types.LOADED_PARENT_TASK_TEMPLATE_SUCCESSFUL,
          parentTaskTemplateItems: [...parentTaskTemplateItems, ...newTaskTemplateItems],
          // parentTaskTemplateTaskTypesDict: taskTypesIdMap,
          childTasksDictByWorkflowId: {},
        });
      }
    } catch (e) {
      const message = e instanceof Error ? 'Loading Parent Task Template Failed' : e.message;
      dispatch({ type: types.LOADED_PARENT_TASK_TEMPLATE_FAILED });
      logUtils.logError(e, message);
      throw e;
    }
  };
}

export function clearParentTaskTemplate() {
  return async (dispatch) => {
    dispatch({ type: types.CLEAR_PARENT_TASK_TEMPLATE });
  };
}

export function showPicklistsLoading(picklistTypes) {
  return (dispatch) => {
    dispatch({ type: types.LOADING_PICKLISTS, picklistTypes });
  };
}

export function stopShowingPicklistsLoading(picklistTypes) {
  return (dispatch) => {
    dispatch({ type: types.STOP_LOADING_PICKLISTS, picklistTypes });
  };
}

export function newEditBulkTasks(tasks, username) {
  return async (dispatch) => {
    dispatch(bulkEditPageLoading());
    try {
      const clonedTasks = _.cloneDeep(tasks);
      for (const task of clonedTasks) {
        delete task.asset;
        delete task.assignee;
        delete task.taskType;
        delete task.isDirty;
        delete task.isVirtual;
      }
      const response = await apiService.publishTasks(clonedTasks, username, false, false);
      if (_.get(response, 'data.rpcService.success')) {
        dispatch(upsertTasks(tasks));
        dispatch(stopBulkEditPageLoading());
        toastr.success(`${tasks.length} Task(s) Updated`);
      } else {
        throw response;
      }
    } catch (e) {
      logUtils.logError(e, 'Update Tasks failed');
      dispatch(stopBulkEditPageLoading());
      throw e;
    }
  };
}

export function loadBulkEditWatcherPickList(asset) {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_PICKLIST, picklistType: PICKLIST_OPTIONS.NOTIFICATION_WATCHERS });
    try {
      const tempAreaIds = [];
      asset.forEach((assetObj) => {
        tempAreaIds.push(assetObj.areas.filter((a) => !a.isDeleted).map((e) => e.areaId));
      });

      const [reqAsset] = asset;
      const promises = tempAreaIds.map((areaIds) =>
        apiService.getUsersByTeamIdsAndAreaIds([], areaIds, reqAsset.fieldId)
      );
      const response = await Promise.all(promises);
      const watchersResponse = response.map((res) => JSON.parse(_.get(res, 'data.rpcService.output') || '[]'));
      const watchers = _.intersectionBy(...watchersResponse, 'id');

      dispatch({
        type: types.LOAD_PICKLIST_SUCCESSFUL,
        picklistType: PICKLIST_OPTIONS.NOTIFICATION_WATCHERS,
        entities: watchers,
      });
      dispatch(upsertWatchers(_.keyBy(watchers, 'id')));
    } catch (e) {
      logUtils.logError(e, 'Watchers loading failed');
      dispatch({ type: types.LOAD_PICKLIST_FAILED, picklistType: PICKLIST_OPTIONS.NOTIFICATION_WATCHERS });
    }
  };
}

export function loadWatchersPicklist(asset) {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_PICKLIST, picklistType: PICKLIST_OPTIONS.NOTIFICATION_WATCHERS });
    try {
      const areaIds = asset.areas.filter((a) => !a.isDeleted).map((a) => a.areaId);
      // const response = await apiService.getUserByAreas(areaIds);
      // const watchers = _.get(response, 'data.getUserByAreas', []);

      const watchersResponse = await apiService.getUsersByTeamIdsAndAreaIds([], areaIds, asset.fieldId);
      if (!_.get(watchersResponse, 'data.rpcService.success')) {
        throw watchersResponse;
      }
      let watchers = _.get(watchersResponse, 'data.rpcService.output');
      watchers = JSON.parse(watchers);
      dispatch({
        type: types.LOAD_PICKLIST_SUCCESSFUL,
        picklistType: PICKLIST_OPTIONS.NOTIFICATION_WATCHERS,
        entities: watchers,
      });
      dispatch(upsertWatchers(_.keyBy(watchers, 'id')));
      return watchers;
    } catch (e) {
      logUtils.logError(e, 'Watchers loading failed');
      dispatch({ type: types.LOAD_PICKLIST_FAILED, picklistType: PICKLIST_OPTIONS.NOTIFICATION_WATCHERS });
      return [];
    }
  };
}

export function loadPartsPicklist(taskType) {
  return async (dispatch) => {
    const pickListIds = taskType.partsPicklist || [];
    dispatch({ type: types.LOADING_PICKLIST, picklistType: PICKLIST_OPTIONS.PARTS_PICKLIST });
    try {
      const response = await apiService.getPicklistByPicklistIds(pickListIds);

      dispatch({
        type: types.LOAD_PICKLIST_SUCCESSFUL,
        picklistType: PICKLIST_OPTIONS.PARTS_PICKLIST,
        entities: response,
      });
    } catch (e) {
      logUtils.logError(e, 'load Parts Picklist failed');
      dispatch({ type: types.LOAD_PICKLIST_FAILED, picklistType: PICKLIST_OPTIONS.PARTS_PICKLIST });
    }
  };
}

export function loadPicklistsForTask({ task, taskType, schema, component, bulkEditForm = false, taskTypeList }) {
  return async (dispatch, getState) => {
    const { fieldId } = component.props;
    const { asset } = task;
    loadOptionsForCustomPicklists(dispatch, schema, getState);
    dispatch(
      showPicklistsLoading([
        PICKLIST_OPTIONS.ASSIGNEE,
        PICKLIST_OPTIONS.TASK_TYPE,
        PICKLIST_OPTIONS.NOTIFICATION_WATCHERS,
        PICKLIST_OPTIONS.PARTS_PICKLIST,
      ])
    );
    const taskTypes = taskTypeList?.length ? taskTypeList : [taskType];
    await loadTaskTypePicklist({ taskTypes })(dispatch, getState);
    const taskTypeOptions = _.get(component, 'props.taskTypeOptions', {});
    const taskTypeOption =
      !_.isEmpty(taskTypeOptions) &&
      taskTypeOptions.items.find((taskTypeItem) => taskTypeItem.value === task.taskTypeId);
    if (!bulkEditForm) {
      if (!taskTypeOption) {
        const errorObj = {
          message: 'Task Type not found',
          rootCause: `task type ${task.taskTypeId} not found for the field ${fieldId}`,
        };
        logUtils.logError(errorObj, errorObj.message);
        dispatch(
          stopShowingPicklistsLoading([
            PICKLIST_OPTIONS.ASSET,
            PICKLIST_OPTIONS.ASSIGNEE,
            PICKLIST_OPTIONS.NOTIFICATION_WATCHERS,
            PICKLIST_OPTIONS.PARTS_PICKLIST,
          ])
        );
        return;
      }
    }
    const promise = [
      loadAssigneePicklist(asset, taskTypeOption.originalobject, fieldId)(dispatch, getState),
      loadWatchersPicklist(task.asset)(dispatch),
      loadPartsPicklist(taskType)(dispatch),
    ];
    let stopId = task.assetId;
    if (asset.type !== 'stop') {
      stopId = asset.stopId;
      loadAssetLevelsPicklist(asset.id)(dispatch);
    }

    promise.push(
      loadAssetPicklist({ taskType: taskTypeOption.originalobject, searchString: '', stopId })(dispatch, getState)
    );

    promise.push(getStop(asset.stopId)(dispatch));
    await Promise.all(promise);
  };
}

export function loadManifestForm(taskType, task = {}) {
  // check for formSchemaId
  const taskTypeChanged =
    task?.id &&
    !TaskUtilities.isTaskChild(task) &&
    !TaskUtilities.isTaskOccurrenceOfRecurring(task) &&
    TaskUtilities.isTaskRegular(task) &&
    taskType.formSchemaId !== task?.formSchemaId;
  const formDataIds = [];
  if (task?.parentTaskId) {
    formDataIds.push(task.parentTaskId);
  }
  if (task?.id) {
    formDataIds.push(task.id);
  }
  return async (dispatch) => {
    // eslint-disable-next-line no-nested-ternary
    let formSchemaId = task ? task.formSchemaId : taskType ? taskType.formSchemaId : null;
    if (taskTypeChanged) {
      formSchemaId = taskType.formSchemaId;
    }
    dispatch({ type: types.LOADING_MANIFEST_FORM });
    try {
      let picklist = [];
      let data = {};
      let schema = {};
      if (formSchemaId) {
        const formSchemas = await apiService.getFormsByFormIds([formSchemaId]);
        [schema] = formSchemas;
        const picklistIds = getPicklistIds(schema.data, []);
        const assetListFormElements = getFormElementsForAssetList(schema.data, []);
        const promises = [];
        if (picklistIds && picklistIds.length) {
          promises.push(apiService.getPicklistByPicklistIds(picklistIds));
        }
        // getData
        if (formDataIds.length) {
          promises.push(apiService.getFormsByFormIds(formDataIds));
        }
        if (picklistIds?.length > 0 && formDataIds.length > 0) {
          const [picklistRes, formData] = await Promise.all(promises);
          [data = {}] = formData || [];
          picklist = picklistRes;
        } else if (picklistIds?.length > 0) {
          const [picklistRes] = await Promise.all(promises);
          picklist = picklistRes;
        } else if (formDataIds.length > 0) {
          const [formData] = await Promise.all(promises);
          [data = {}] = formData || [];
        }
        // check if schema has task asset list metadata
        // check if form data has any value
        // fetch asset and add it to picklist options
        if (task?.id && assetListFormElements?.length) {
          const assetListPicklist = [];
          for (const { elemId, sectionId } of assetListFormElements) {
            if (sectionId && _.get(data, `data.${sectionId}.${elemId}`)) {
              assetListPicklist.push({
                id: elemId,
                options: {
                  [_.get(data, `data.${sectionId}.${elemId}.id`)]: _.get(data, `data.${sectionId}.${elemId}`),
                },
              });
            }
            if (data?.data?.[elemId]) {
              assetListPicklist.push({
                id: elemId,
                options: { [data?.data?.[elemId]?.id]: data?.data?.[elemId] },
              });
            }
          }
          dispatch({ type: types.SEARCH_PICKLIST_FOR_FORM, updatedPicklists: assetListPicklist });
        }
      }
      // do we need to change the formdata
      dispatch({
        type: types.LOAD_MANIFEST_FORM_SUCCESSFUL,
        picklist,
        schema,
        data: taskTypeChanged ? {} : data,
      });
      if (formSchemaId && data?.id) {
        try {
          const auditLog = await apiService.getAuditLogOfForm(data.id);
          dispatch({
            type: types.SET_AUDIT_LOG_OF_MANIFEST_FORM,
            auditLog,
          });
        } catch (e) {
          logUtils.logError(e);
        }
      }
    } catch (e) {
      logUtils.logError(e, 'load form failed');
      dispatch({ type: types.LOAD_MANIFEST_FORM_FAILED });
    }
  };
}

async function loadTaskHistory(dispatch, taskId, parentTaskId) {
  try {
    const [taskHistoryResponse, taskEmailHistoryResponse] = await Promise.allSettled([
      apiService.getTaskHistory({ id: taskId, parentTaskId, timeZone: moment.tz.guess() }),
      apiService.getTaskEmailHistory({ taskId }),
    ]);
    const taskHistory = _.get(taskHistoryResponse, 'value', []);
    const taskEmailHistory = _.get(taskEmailHistoryResponse, 'value', []);
    if (taskHistory) {
      dispatch({ type: types.LOAD_FORM_HISTORY, taskHistory });
    } else {
      toastr.error('Failed to fetch Audit details');
    }
    dispatch({ type: types.LOAD_TASK_EMAIL_HISTORY_SUCCESSFUL, taskEmailHistory });
  } catch (error) {
    logUtils.logError(error, 'load Task History failed');
    dispatch({ type: types.LOAD_TASK_EMAIL_HISTORY_FAILED });
  }
}

async function loadRulesEvaluated(dispatch, taskId) {
  try {
    const evaluatedRules = await apiService.getAllEvalutedRulesOfATask({ id: taskId });

    dispatch({ type: types.LOAD_RULES_EVALUATED_SUCCESSFUL, evaluatedRules });
  } catch (error) {
    logUtils.logError(error, 'load Rules Evaluated failed');
    dispatch({ type: types.LOAD_RULES_EVALUATED_FAILED });
  }
}

const onFetchingAssignees = async (selectedTasks) => {
  try {
    const taskIds = selectedTasks.map((task) => task.id);

    const assigneesList = await apiService.getAssigneeList(taskIds);
    return assigneesList;
  } catch (e) {
    logUtils.logError(e, 'Error fetching assignee list');
    return [];
  }
};

function tempTaskTypeSchemaFilter(taskTypeAttributeSchema) {
  const tempObj = {};
  for (const [key, value] of Object.entries(taskTypeAttributeSchema)) {
    if (value.parentPickListIds) {
      continue;
    }
    if (value.mappingId) {
      continue;
    }
    if (value.metadataInfo) {
      continue;
    }
    tempObj[key] = value;
  }

  return tempObj;
}

export function loadBulkEdittaskForm(taskList, similarTaskType, taskListIds) {
  return async (dispatch, getState) => {
    try {
      const { loggedInUser, selectedField } = getState().appReducer;
      bulkEditPageLoading();
      // const fieldId = getState().appReducer.selectedField.id;
      const allTasks = getState().taskViewPageReducer.tasks.items;
      const { workRequests, approvalRequests } = getState().approvalTasksReducer;

      let stask = [];
      const tasksInReducer = [...allTasks, ...workRequests, ...approvalRequests];
      for (const taskObj of taskList) {
        const reqTask = tasksInReducer.find((t) => t.id === taskObj.id);
        stask.push(reqTask);
      }

      if (!stask) {
        [stask] = await getTasksByIds(taskListIds);
      }
      if (!stask) {
        toastr.error('Task Details could not be fetched');
        return;
      }

      // const task = JSON.parse(JSON.stringify(stask));
      const task = _.cloneDeep(BULK_EDIT_TASK);
      const assigneeList = await onFetchingAssignees(taskList);
      dispatch({
        type: types.LOAD_PICKLIST_SUCCESSFUL,
        picklistType: PICKLIST_OPTIONS.ASSIGNEE,
        entities: assigneeList,
      });
      const assetList = [];
      taskList.forEach((taskObj) => {
        const { asset } = taskObj;
        if (asset) assetList.push(asset);
      });
      if (assetList && assetList.length && assetList.length === taskList.length) {
        await loadBulkEditWatcherPickList(assetList)(dispatch);
      }
      dispatch(loadWatcherGroups(selectedField?.id));

      if (similarTaskType) {
        const taskTypeResponse = await apiService.getTaskTypeById(taskListIds[0]);
        const taskType = _.get(taskTypeResponse, 'data.getTaskType');

        const taskGlobalAttributes = (getState().globalAttributeReducer.attributes || []).filter(
          (attr) => attr.entityType === 'task'
        );

        const globalAttributesToShow = taskType?.globalAttributes || [];

        const globalAttributeDict = _.keyBy(taskGlobalAttributes, 'id');
        const filteredGlobalAttributes = globalAttributesToShow
          .map((id) => {
            if (globalAttributeDict[id]) {
              return globalAttributeDict[id];
            }
            return null;
          })
          .filter((attr) => {
            if (attr) {
              if (!_.isEmpty(attr.parentPickListIds)) {
                return false;
              }
              if (!_.isEmpty(attr.mappingId)) {
                return false;
              }
              if (!_.isEmpty(attr.metadataInfo)) {
                return false;
              }
              return true;
            }
            return false;
          });

        const globalSchema = createSchemaFromTaskGlobalAttributes(filteredGlobalAttributes, '', '', true, loggedInUser);
        const schemaString = _.get(taskTypeResponse, 'data.getTaskType.schema');
        const tempTaskTypeSchema = schemaString ? JSON.parse(schemaString) : {};
        const taskTypeSchema = tempTaskTypeSchemaFilter(tempTaskTypeSchema);
        const schema = { ...taskTypeSchema, ...globalSchema };
        addSchemaRelatedPropertiesToCustomAndGlobalAttributes(schema, getState, false);
        loadOptionsForCustomPicklists(dispatch, schema, getState);
        dispatch({ type: types.LOAD_CREATE_BULK_FORM_SCHEMA_AND_VALUES, task, schema });

        // dispatch(
        //   loadPicklistsForTask({
        //     task,
        //     taskType,
        //     schema,
        //     component: { props: { fieldId, taskTypeOptions: {} } },
        //     bulkEditForm: true,
        //   })
        // );
        // loadDependentTasks(dispatch, task, allTasks);
        // loadLinkedTasks(dispatch, task, allTasks);
        // dispatch(loadManifestForm(taskType, task));
        // loadTaskTemplate(dispatch, task);
        // loadTaskHistory(dispatch, task.id);
        stopBulkEditPageLoading();
      } else {
        dispatch({ type: types.LOAD_CREATE_BULK_FORM_SCHEMA_AND_VALUES, task, schema: {} });
        stopBulkEditPageLoading();
      }
    } catch (e) {
      const message = e instanceof Error ? 'Loading Task Failed' : e.message;
      logUtils.logError(e, message);
      stopBulkEditPageLoading();

      throw e;
    }
  };
}

export function isTaskTypeParent(state) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.IS_TASK_TYPE_PARENT, taskTypeSelectedisParent: state });
    } catch (e) {
      console.error(e);
    }
  };
}

export function loadTaskForm({ taskId, component }) {
  return async (dispatch, getState) => {
    try {
      const { loggedInUser } = getState().appReducer;
      const fieldId = getState().appReducer.selectedField.id;
      const allTasks = getState().taskViewPageReducer.tasks.items;
      const { taskTypes = [] } = getState().taskTypeReducer;
      const { workRequests, approvalRequests } = getState().approvalTasksReducer;
      let stask = [...allTasks, ...workRequests, ...approvalRequests].find((t) => t.id === taskId);
      if (!stask) {
        [stask] = await getTasksByIds([taskId]);
      }
      if (!stask) {
        toastr.error('Task Details could not be fetched');
        dispatch(loadCreateTaskForm({ fieldId }, allTasks));
        return;
      }
      const task = JSON.parse(JSON.stringify(stask));

      loadPicklists()(dispatch);
      const taskType = taskTypes.find((tt) => tt.id === task.taskTypeId) || {};
      const taskTypeList = taskTypes.filter((tt) => tt.id === taskType?.id || !tt.isParent);
      const taskGlobalAttributes = (getState().globalAttributeReducer.attributes || []).filter(
        (attr) => attr.entityType === 'task'
      );
      let globalAttributesToShow = taskType?.globalAttributes || [];
      let rollupGlobalAttributes = taskType?.rollupGlobalAttributes || [];
      const { parentTaskId } = task;

      if (TaskUtilities.isTaskParent(task)) {
        dispatch(isTaskTypeParent(true));
      }
      if (parentTaskId) {
        let parentTask = allTasks.find((t) => t.id === parentTaskId);
        if (!parentTask) {
          const apiResponse = await getTasksByIds([parentTaskId]);
          parentTask = apiResponse && apiResponse.length ? apiResponse[0] : {};
        }

        if (parentTask && parentTask.taskType && parentTask.taskType.globalAttributes) {
          globalAttributesToShow = parentTask.taskType.globalAttributes;
          rollupGlobalAttributes = parentTask.taskType.rollupGlobalAttributes || [];
        }
      }
      const globalAttributeDict = _.keyBy(taskGlobalAttributes, 'id');
      const filteredGlobalAttributes = globalAttributesToShow
        .map((id) => {
          if (globalAttributeDict[id]) {
            return globalAttributeDict[id];
          }
          return null;
        })
        .filter((attr) => attr);

      const globalSchema = createSchemaFromTaskGlobalAttributes(
        filteredGlobalAttributes,
        parentTaskId,
        taskId,
        null,
        loggedInUser,
        rollupGlobalAttributes
      );
      const taskTypeSchema = taskType.schema ? taskType.schema : {};
      const schema = { ..._.cloneDeep(taskTypeSchema), ...globalSchema };
      addSchemaRelatedPropertiesToCustomAndGlobalAttributes(schema, getState, !taskId);
      dispatch({ type: types.LOAD_FORM_SCHEMA_AND_VALUES, task, schema });
      dispatch(loadPicklistsForTask({ task, taskType, schema, component, taskTypeList }));
      loadDependentTasks(dispatch, task, allTasks);
      loadLinkedTasks(dispatch, task, allTasks, loggedInUser);
      dispatch(loadManifestForm(taskType, task));
      loadTaskTemplate(dispatch, task);
      loadTaskHistory(dispatch, task.id, task.parentTaskId);
      if (task?.taskType?.triggerTasksUsingRules) {
        loadRulesEvaluated(dispatch, task.id);
      }
      if (TaskUtilities.isTaskParent(task)) {
        dispatch(loadParentTaskTemplate(taskType, task.id, task));
      }
    } catch (e) {
      const message = e instanceof Error ? 'Loading Task Failed' : e.message;
      logUtils.logError(e, message);
      throw e;
    }
  };
}

function manageAssigneeIds({ taskType, assigneeIds, formik, assignees }) {
  let filteredAssigneeIds = [];
  if (taskType?.needEquipment) {
    formik.setFieldValue('s_assigneeid', filteredAssigneeIds, false);
  } else {
    const assigneesFound = assignees.filter(({ id }) => (formik?.values?.s_assigneeid ?? []).includes(id));
    filteredAssigneeIds = (assigneesFound || []).map((val) => val.id);
    formik.setFieldValue('s_assigneeid', [...filteredAssigneeIds, ''], false);
  }

  assigneeIds.forEach((assignee) => {
    if (filteredAssigneeIds.includes(assignee.assigneeId)) {
      delete assignee.isAccepted;
      delete assignee.acceptedOn;
    }
  });
}

export function loadSchemaForTaskType(
  taskType,
  formik,
  assigneeOptions,
  assetOptions,
  taskTypeOptions,
  customPicklistOptions,
  stopOptions,
  originalTask
) {
  return async (dispatch, getState) => {
    const { loggedInUser, selectedField } = getState().appReducer;
    const defaultSchema = _.cloneDeep(DEFAULT_TASK_SCHEMA);
    const taskGlobalAttributes = (getState().globalAttributeReducer.attributes || []).filter(
      (attr) => attr.entityType === 'task'
    );
    const globalAttributesToShow = taskType.globalAttributes || [];
    const rollupGlobalAttributes = taskType.rollupGlobalAttributes || [];

    const globalAttributeDict = _.keyBy(taskGlobalAttributes, 'id');
    const filteredGlobalAttributes = globalAttributesToShow
      .map((id) => {
        if (globalAttributeDict[id]) {
          return globalAttributeDict[id];
        }
        return null;
      })
      .filter((attr) => attr);

    const globalSchema = createSchemaFromTaskGlobalAttributes(
      filteredGlobalAttributes,
      '',
      null,
      null,
      loggedInUser,
      rollupGlobalAttributes
    );
    const taskTypeSchema = _.cloneDeep(taskType.schema);
    // check this schema
    const schema = { ...taskTypeSchema, ...defaultSchema, ...globalSchema };
    const { taskFormMode, parentLinkedTask } = getState().manageTaskFormReducer;
    if (taskType?.defaultLocationTask) {
      const { task } = getState().manageTaskFormReducer;
      const reqTaskClone = _.cloneDeep(task);
      const { assigneeIds } = reqTaskClone;
      dispatch({ type: types.LOADING_PICKLIST, picklistType: PICKLIST_OPTIONS.ASSIGNEE });
      const [stopResponse] = await loadStopPicklist({
        taskType,
        searchString: `${selectedField?.fieldCode ?? ''}-default-stop`,
      })(dispatch, getState);
      formik.setFieldValue('s_stop', stopResponse?.id ?? '', false);
      const assignees = await loadAssigneePicklist(stopResponse, taskType, selectedField?.id)(dispatch, getState);
      manageAssigneeIds({ taskType, assigneeIds, formik, assignees });
      dispatch(updateTaskInReducer(reqTaskClone));
    }

    if (parentLinkedTask) {
      schema.s_tasktype.onChange = ON_TASK_TYPE_CHANGE_FOR_LINKED_TASKS;
      schema.s_stop.disabled = true;
      schema.s_asset.disabled = true;
    }

    if (taskFormMode === TASK_FORM_MODE.UPDATE) {
      const { task } = getState().manageTaskFormReducer;
      const reqTaskClone = _.cloneDeep(task);
      const { assigneeIds } = reqTaskClone;
      if (!taskType?.defaultLocationTask) {
        const promise = [
          loadAssigneePicklist(originalTask?.asset, taskType, originalTask?.fieldId)(dispatch, getState),
        ];
        if (originalTask?.asset?.type !== 'stop') {
          promise.push(
            loadAssetPicklist({ taskType, id: originalTask?.assetId ?? '', stopId: originalTask.asset.stopId })(
              dispatch,
              getState
            )
          );
        } else {
          promise.push(
            loadAssetPicklist({ taskType, searchString: '', stopId: originalTask.assetId })(dispatch, getState)
          );
        }
        promise.push(loadStopPicklist({ taskType, id: originalTask?.asset?.stopId ?? '' })(dispatch, getState));
        const [assignees, ...assetPromiseResponse] = await Promise.all(promise);
        const assetsList = assetPromiseResponse.flatMap((val) => val);
        const assetInResponse = assetsList.find((val) => val.id === formik?.values?.s_asset);
        const stopInResponse = assetsList.find((val) => val.id === formik?.values?.s_stop);
        if (!stopInResponse) {
          formik.setFieldValue('s_stop', '', false);
          formik.setFieldValue('notification_watchers', [], false);
        }
        if (!assetInResponse) {
          formik.setFieldValue('s_asset', '', false);
        }
        manageAssigneeIds({ taskType, assigneeIds, formik, assignees });
      }
      Object.keys(taskTypeSchema || {}).forEach((key) => {
        if (key?.startsWith('c_')) {
          const val = getDefaultValue(taskTypeSchema[key]);
          formik.setFieldValue(key, val, false);
        }
      });

      dispatch(updateTaskInReducer(reqTaskClone));
    }

    dispatch(loadPartsPicklist(taskType));
    dispatch(loadManifestForm(taskType, originalTask.id ? originalTask : null));
    const customOptionList = await loadOptionsForCustomPicklists(dispatch, schema, getState);
    const globalAndCustomAttr = addSchemaRelatedPropertiesToCustomAndGlobalAttributes(schema, getState, true);
    findAffectingChild({
      attributes: globalAndCustomAttr,
      entityVal: taskType,
      entityType: 'tasktype',
      formValues: { ..._.cloneDeep(_.get(formik, 'values') || {}), s_tasktype: taskType.id },
      formik,
      customPicklistOptions: customOptionList,
      taskTypeOptions,
      assetOptions,
      assigneeOptions,
      stopOptions,
    });
    // dispatch here schema
    dispatch({ type: types.LOAD_FORM_SCHEMA, schema });
  };
}

export function resetTaskFormComponent() {
  return (dispatch) => {
    dispatch({ type: types.RESET_TASK_FORM_COMPONENT });
  };
}

export function deleteLinkedTask(taskId) {
  return async (dispatch) => {
    try {
      const response = await apiService.deleteTask({ id: taskId });
      const deletedTask = _.get(response, 'data.deleteTask');
      if (deletedTask) {
        dispatch({ type: types.DELETED_LINKED_TASK_SUCCESSFULLY, task: deletedTask });
      } else {
        throw new Error('Task could not be deleted');
      }
    } catch (e) {
      logUtils.logError(e, "Linked Task couldn't be deleted");
    }
  };
}

export function clearStop() {
  return async (dispatch) => {
    dispatch({ type: types.CLEAR_STOP });
  };
}

export function clearManifestForm() {
  return async (dispatch) => {
    dispatch({ type: types.CLEAR_MANIFEST_FORM });
  };
}

export function generateMultipleTask({ taskCount, tasksToCopy, taskId }) {
  return async (dispatch, getState) => {
    try {
      const { loggedInUser } = getState().appReducer;
      const allTasks = getState().taskViewPageReducer.tasks.items;
      const response = await apiService.generateMultipleTasksApi({
        tasksToCopy,
        parentTaskId: taskId,
        taskCount: parseInt(taskCount),
      });
      const { parentTask, generatedTasks } = response;
      if (parentTask && generatedTasks) {
        loadLinkedTasks(dispatch, parentTask, [...allTasks, parentTask, ...generatedTasks], loggedInUser);
        const updatedTasks = [parentTask, ...generatedTasks].map((task) => {
          task.assignee = JSON.stringify(task.assignee);
          task.data = JSON.stringify(task.data);
          return task;
        });
        dispatch(upsertTasks(updatedTasks));
        dispatch({ type: types.UPDATE_TASK_AFTER_GENERATE_MULTIPLE, task: parentTask });
      } else {
        throw new Error('Tasks could not be generated');
      }
    } catch (e) {
      logUtils.logError(e, 'Tasks could not be generated');
      throw e;
    }
  };
}

export function setIsAdhocFileUploading(flag) {
  return { type: types.SET_ADHOC_FILE_UPLOADING_STATUS, flag };
}

export function bulkAcceptTaskAction(selectedTasks) {
  return async (dispatch) => {
    try {
      selectedTasks.forEach((taskObj) => {
        const { assigneeIds, taskType } = taskObj;
        let updatedAssigneeIds = [];
        if (taskType?.needEquipment) {
          const { equipmentId, operatorId } = TaskUtilities.getOperatorIdAndEquipmentId(assigneeIds);
          updatedAssigneeIds = TaskUtilities.getUpdatedAssigneeOnAcceptingTask(assigneeIds, equipmentId, operatorId);
        } else {
          updatedAssigneeIds = TaskUtilities.getUpdatedAssigneeOnAcceptingTask(assigneeIds, assigneeIds[0].assigneeId);
        }
        taskObj.assigneeIds = updatedAssigneeIds;
        taskObj.status = 'open';
        dispatch(updateTaskInReducer(taskObj));
      });
    } catch (e) {
      logUtils.logError(e, 'Tasks could not be accepted');
    }
    return selectedTasks;
  };
}

export function acceptRejectTask(data, type = 'accept') {
  return async (dispatch, getState) => {
    const { assigneeId, operatorId } = data;
    const { task } = getState().manageTaskFormReducer;
    const reqTaskClone = _.cloneDeep(task);
    if (type === 'accept') {
      const { assigneeIds = [] } = reqTaskClone;
      const updatedAssigneeids = TaskUtilities.getUpdatedAssigneeOnAcceptingTask(assigneeIds, assigneeId, operatorId);
      reqTaskClone.assigneeIds = updatedAssigneeids;
      if (!TaskUtilities.isTaskChild(task)) {
        reqTaskClone.status = 'open';
      }
    } else if (type === 'reject') {
      const { assigneeIds } = reqTaskClone;
      const reqAssignee = assigneeIds.find((assignee) => assignee.assigneeId === assigneeId);
      reqAssignee.isDeleted = true;
      if (reqAssignee.operatorId) {
        const reqAssigneeOperator = assigneeIds.find((assignee) => assignee.assigneeId === reqAssignee.operatorId);
        if (reqAssigneeOperator) {
          reqAssigneeOperator.isDeleted = true;
        }
      }
      if (!reqTaskClone.rejectedIds) {
        reqTaskClone.rejectedIds = [];
      }
      reqTaskClone.rejectedIds.push({
        rejectedOn: new Date().toISOString(),
        id: assigneeId,
      });
    }
    dispatch(updateTaskInReducer(reqTaskClone));
  };
}

export function acceptRejectTaskInReducer(data, type = 'accept') {
  return async (dispatch, getState) => {
    const { assigneeId } = data;
    const { task } = getState().manageTaskFormReducer;
    const reqTaskClone = _.cloneDeep(task);
    if (type === 'accept') {
      const { assigneeIds } = reqTaskClone;
      const reqAssignee = assigneeIds.find((assignee) => assignee.assigneeId === assigneeId) || { assigneeId };
      reqAssignee.isAccepted = true;
      reqAssignee.acceptedOn = new Date().toISOString();
      reqAssignee.isDeleted = false;
      const updatedAssigneeids = [reqAssignee];
      assigneeIds.forEach((a) => {
        if (a.assigneeId && a.assigneeId !== reqAssignee.assigneeId) {
          updatedAssigneeids.push(_.omit({ ...a, isDeleted: true }, ['isAccepted', 'acceptedOn']));
        }
      });
      reqTaskClone.assigneeIds = updatedAssigneeids;
      if (!TaskUtilities.isTaskChild(task)) {
        reqTaskClone.status = 'open';
      }
    }
    dispatch(updateTaskInReducer(reqTaskClone));
  };
}

export function updateAssetSearchPicklistForForm({ selectedTT, stopId, searchString, data }) {
  return async (dispatch, getState) => {
    let assets = [];
    const taskType = selectedTT?.originalobject;
    if (!taskType || !stopId) {
      if (!stopId) {
        toastr.error('No Stop Selected');
      } else if (!taskType) {
        toastr.error('No TaskType Selected');
      }
      return;
    }
    const { selectedField } = getState().appReducer;
    const accessToFieldAndAreas = getFieldsAndAreasAccessibleToUser(getState().appReducer.loggedInUser);
    const areaIds = accessToFieldAndAreas[selectedField.id] ?? [];
    if (taskType) {
      assets = await getAssetOptions({ taskType, stopId, areaIds, searchString });
    }
    const picklist = { id: data.name, name: data.name, options: _.keyBy(assets, 'id') };
    dispatch({ type: types.SEARCH_PICKLIST_FOR_FORM, updatedPicklists: [picklist] });
  };
}
